"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var currency_1 = require("../../utilities/currency");
var content = __importStar(require("./Breakdown.content"));
var Breakdown_styles_1 = require("./Breakdown.styles");
var Table = function (_a) {
    var hasLien = _a.hasLien, lienAmount = _a.lienAmount, lienItemLabel = _a.lienItemLabel, _b = _a.positiveText, positiveText = _b === void 0 ? content.paymentToYou : _b, value = _a.value;
    var lienAsNegative = lienAmount * -1;
    var totalValue = value + lienAsNegative;
    var valueAmount = (0, currency_1.currency)(value, false);
    var totalCashValue = (0, currency_1.currency)(totalValue, false, true);
    var lienAmountDisplay = (0, currency_1.currency)(lienAsNegative, true);
    var hasNegativeEquity = totalValue < 0;
    var totalLabel = hasNegativeEquity ? content.amountYouOwe : positiveText;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: hasLien ? ((0, jsx_runtime_1.jsxs)(Breakdown_styles_1.BreakdownTable, __assign({ className: "breakdown-table" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "breakdown-table__row" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "breakdown-table__col-lg" }, { children: content.breakdownAmountLabel })), (0, jsx_runtime_1.jsx)("span", { children: valueAmount })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "breakdown-table__row" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "breakdown-table__col-lg" }, { children: lienItemLabel })), (0, jsx_runtime_1.jsx)("span", { children: lienAmountDisplay })] })), (0, jsx_runtime_1.jsx)(Breakdown_styles_1.HorzonitalRule, {}), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "breakdown-table__row" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: totalLabel }), (0, jsx_runtime_1.jsx)("span", __assign({ className: "strong" }, { children: totalCashValue }))] }))] }))) : ((0, jsx_runtime_1.jsxs)(Breakdown_styles_1.TradeInDetails, __assign({ className: "trade-in-details" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "trade-in-details__line-item" }, { children: content.applyAsDownPaymentLabel })), (0, jsx_runtime_1.jsx)(Breakdown_styles_1.HorzonitalRule, {}), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "trade-in-details__line-item" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: content.yourOfferLabel }), (0, jsx_runtime_1.jsx)("span", __assign({ className: "strong" }, { children: (0, currency_1.currency)(value) }))] }))] }))) }));
};
exports.default = Table;
